import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../../services/api';

export default function AdminShell({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    api.get('/auth/me').then(({ data }) => setCurrentUser(data)).catch(() => {
      localStorage.removeItem('speedtest_token');
      navigate('/admin/login');
    });
  }, [navigate]);

  function logout() {
    localStorage.removeItem('speedtest_token');
    navigate('/admin/login');
  }

  const isResults     = location.pathname === '/admin' || location.pathname === '/admin/';
  const isSubmitters  = location.pathname.startsWith('/admin/submitters');
  const isUsers       = location.pathname.startsWith('/admin/users');
  const isSettings    = location.pathname.startsWith('/admin/settings');

  const navTab = (label, path, active) => (
    <button
      onClick={() => navigate(path)}
      style={{
        background: 'none',
        border: 'none',
        borderBottom: active ? '2px solid var(--accent-orange)' : '2px solid transparent',
        color: active ? 'var(--accent-orange)' : '#9aa3b0',
        fontSize: 13,
        fontWeight: active ? 700 : 500,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        padding: '0 4px',
        height: 56,
        cursor: 'pointer',
        transition: 'color 0.15s, border-color 0.15s',
        fontFamily: 'var(--font-display)'
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Top bar */}
      <header style={{
        background: 'var(--bg-secondary)',
        borderBottom: '1px solid var(--border-dim)',
        padding: '0 24px', height: 56,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexShrink: 0
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
          <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 14, textDecoration: 'none' }}>
            <img src="/hdontap_logo.svg" alt="HDOnTap" style={{ height: 34 }} />
            <span style={{
              color: 'var(--accent-orange)', fontSize: 14, fontWeight: 700,
              letterSpacing: '0.14em', textTransform: 'uppercase', fontFamily: 'var(--font-display)'
            }}>Viewer Feedback Admin</span>
          </a>
          <div style={{ display: 'flex', gap: 18, alignItems: 'center', marginLeft: 8 }}>
            {navTab('Results', '/admin', isResults)}
            {navTab('Submitters', '/admin/submitters', isSubmitters)}
            {navTab('Users', '/admin/users', isUsers)}
            {navTab('Settings', '/admin/settings', isSettings)}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {currentUser?.name && (
            <span style={{ color: '#9aa3b0', fontSize: 13 }}>
              {currentUser.name}
            </span>
          )}
          <button className="btn btn-ghost btn-sm" onClick={logout}
            style={{ color: '#d0d8e4', borderColor: '#3e4a5a' }}>Sign Out</button>
        </div>
      </header>

      {/* Content */}
      <main style={{ flex: 1, padding: '32px 24px', maxWidth: 1400, margin: '0 auto', width: '100%' }}>
        {children}
      </main>
    </div>
  );
}
